import { Button, FormikAutocompleteAsync } from '@vadiun/react-components';

import {
  FormControl,
  InputLabel,
  MenuItem,
  TextField as TextFieldMaterial
} from '@material-ui/core';
import { Query } from '@vadiun/react-hooks-legacy';
import { ApplicantModel } from 'app/client/clientBusiness/Applicant/models/ApplicantModel';
import { AuthorizedModel } from 'app/client/clientBusiness/Authorized/models/Authorized';
import {
  ClientBusinessModel,
  ClientBusinessPartialModel
} from 'app/client/clientBusiness/models/ClientBusiness';
// import { RateModel } from 'app/client/clientBusiness/rates/models/RateModel';
import {
  CANALES_DE_VIAJE /* ViajeTrasladoTipoServicio */
} from 'app/viaje/models';
import { Field, FormikProps } from 'formik';
import { CheckboxWithLabel, Select, TextField } from 'formik-material-ui';
import { AutocompleteRenderInputParams } from 'formik-material-ui-lab';
import { useRef, useState } from 'react';
import { FaSearch } from 'react-icons/fa';
import FormikOnFieldChange from 'shared/components/FormikOnFieldChange';
import ReservaTrasladoSearchSolicitante from '../../components/ReservaTrasladoSearchSolicitante';
import { TransferReservationClientRequeriments } from './TransferReservationClientRequeriments';
import { BusType } from '../../models/TransferReservation';
import InternationalPhones from 'shared/components/phone/InternationalPhones';
import { EventModel } from 'app/eventos/models/Evento';
import { TransferReservationEventField } from './TransferReservationEventField';

interface Props extends FormikProps<any> {
  getClientesByName: (name: string) => Promise<ClientBusinessPartialModel[]>;
  onClienteSelect: (cliente: ClientBusinessPartialModel) => void;
  // onServiceTypeSelect: (type: ViajeTrasladoTipoServicio) => void;
  autorizadosQuery: Query<AuthorizedModel[]>;
  clientBusiness: ClientBusinessModel | undefined;
  // fixedRates: RateModel['categories'][0]['fixedPrices'];
  solicitantes: ApplicantModel[];
  optionsBuses?: BusType[];
  eventsQuery: Query<EventModel[]>;
  selectedEventId?: number;
  isValidation?: boolean;
}

export const TransferReservationBaseForm = ({
  setFieldValue,
  setFieldTouched,
  validateField,
  touched,
  errors,
  values,
  onClienteSelect,
  getClientesByName,
  clientBusiness,
  autorizadosQuery,
  solicitantes,
  eventsQuery,
  selectedEventId,
  isValidation
}: Props) => {
  const [isSearchSolicitanteOpen, setIsSearchSolicitanteOpen] = useState(false);
  const firstLoad = useRef(true);
  const [showFieldsLLTPais, setShowFieldsLLTPais] = useState<boolean>(false);

  return (
    <>
      <FormikOnFieldChange
        field="cliente"
        onChange={(cliente: ClientBusinessPartialModel | null) => {
          if (cliente === null) return;
          if (cliente.has_disabled_current_account) {
            setFieldTouched('cliente', true);
            validateField('cliente');
            return;
          }
          onClienteSelect(cliente);
        }}
      />

      <div className="grid grid-cols-2 grid-rows-1 items-start gap-6 pt-8 pb-4">
        <Field
          name="cliente"
          component={FormikAutocompleteAsync}
          fetchOptions={getClientesByName}
          fullWidth
          getOptionLabel={(cliente: ClientBusinessPartialModel) =>
            cliente.fantasyName
            + (cliente.has_disabled_current_account ? ' (Cuenta inhabilitada)' : '')
          }
          className="w-1/2"
          renderInput={(params: AutocompleteRenderInputParams) => (
            <TextFieldMaterial
              {...params}
              error={touched['cliente'] && !!errors['cliente']}
              helperText={errors['cliente']}
              label="Cliente"
              variant="outlined"
              fullWidth
            />
          )}
        />
        <TransferReservationEventField
          events={eventsQuery.data || []}
          loading={eventsQuery.isLoading}
        />
      </div>

      <div className="grid grid-cols-2 grid-rows-1 gap-6 border-b-2 border-dashed pb-4">
        <div className="py-2 flex items-center">
          <FormikOnFieldChange
            field="isLLTPais"
            onChange={(isLLTPais: null) => {
              if (isLLTPais === null) return;

              if (isLLTPais === false) {
                setFieldValue('providerPrice', '');
                setFieldValue('customerPrice', '');
              }

              setShowFieldsLLTPais(isLLTPais);
            }}
          />
          <div className="w-32">
            <Field
              component={CheckboxWithLabel}
              type="checkbox"
              name="isLLTPais"
              color="primary"
              Label={{ label: 'LLT País' }}
            />
          </div>
          {showFieldsLLTPais ? (
            <div className="flex gap-4">
              <Field
                name="providerPrice"
                label="Costo proveedor"
                variant="outlined"
                component={TextField}
                type="number"
              />
              <Field
                name="customerPrice"
                label="Costo cliente"
                variant="outlined"
                component={TextField}
                type="number"
              />
            </div>
          ) : null}
        </div>
        <div className="w-1/3">
          <Field
            component={CheckboxWithLabel}
            type="checkbox"
            name="pay_with_cash"
            color="primary"
            Label={{ label: 'Pago en efectivo' }}
          />
        </div>
      </div>

      <TransferReservationClientRequeriments
        autorizadosQuery={autorizadosQuery}
        errors={errors}
        client={clientBusiness}
        isValidation={isValidation}
      />

      <div className="grid grid-cols-11 gap-6 border-b-2 border-dashed py-8">
        <Button
          variant="light"
          shape="circle"
          onClick={() => setIsSearchSolicitanteOpen(true)}
          className="col-span-1 self-center"
        >
          <FaSearch />
        </Button>
        <ReservaTrasladoSearchSolicitante
          isOpen={isSearchSolicitanteOpen}
          handleClose={() => setIsSearchSolicitanteOpen(false)}
          solicitantes={solicitantes}
          onSelect={(solicitante) => {
            setFieldValue('solicitante.name', solicitante.name);
            setFieldValue('solicitante.phone', solicitante.phone ?? '');
            setFieldValue('solicitante.email', solicitante.email);
            setIsSearchSolicitanteOpen(false);
          }}
        />
        <Field
          name="solicitante.name"
          label="Solicitante"
          variant="outlined"
          component={TextField}
          className="col-span-4"
          fullWidth
        />
        <div className="w-full col-span-3">
          <InternationalPhones
            name="solicitante.phone"
            label="Teléfono"
            variant="floating"
          />
        </div>
        <Field
          name="solicitante.email"
          label="Mail"
          variant="outlined"
          component={TextField}
          fullWidth
          className="col-span-3"
        />
      </div>
      <div className="grid grid-cols-12 gap-6 border-b-2 border-dashed pt-8 pb-4">
        <FormControl variant="outlined" fullWidth className="col-span-3">
          {isValidation ? (
            <div className=" border-dashed ">
              <Field
                name="canalIngreso"
                label="Canal de ingreso"
                variant="outlined"
                component={TextField}
                fullWidth
              />
            </div>
          ) : (
            <>
              <InputLabel>Canal de ingreso</InputLabel>
              <Field
                component={Select}
                name="canalIngreso"
                label="Canal de ingreso"
              >
                {CANALES_DE_VIAJE.map((canal) => (
                  <MenuItem value={canal} key={canal}>
                    {canal}
                  </MenuItem>
                ))}
              </Field>
            </>
          )}
        </FormControl>
        <Field
          name="plataformaId"
          label="ID plataforma"
          variant="outlined"
          component={TextField}
          className="col-span-3"
          fullWidth
        />
      </div>
      <div className="border-b-2 border-dashed py-8 ">
        <Field
          name="observacionCoordinacion"
          label="Observacion coordinacion"
          variant="outlined"
          component={TextField}
          fullWidth
        />
      </div>
      <div className="border-b-2 border-dashed py-8 ">
        <Field
          name="general_observation"
          label="Observacion Chofer"
          variant="outlined"
          component={TextField}
          fullWidth
        />
      </div>
    </>
  );
};
